export enum ConfigurationStatusType {
  CREATED = 'created',
  MODIFIED = 'modified',
  AUTO_VALIDATED_CORRECT = 'auto_validated_correct',
  AUTO_VALIDATED_ERROR = 'auto_validated_error',
  CORRECT = 'correct',
  ERROR = 'error'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/configurationstatustype.ts